import {gql} from "@apollo/client";

const universityUserFragment = gql`
    fragment UniversityUserFull on UniversityUserField {
        id
        firstName
        lastName
        university {
            id
            name
            slug
            isFeatureEnabled(feature: "customAttributes")
            marketplaces {
                name
                slug
                id
            }
        }
        isOnline
        phoneNumber
        preferences {
            newMessageNotifications
        }
        groups {
            type
        }
    }
`;

export default universityUserFragment;
